import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';

import BlogBlockRenderer from '../components/BlogBlockRenderer';
import { useLanguage } from '../context/LanguageContext';
import { apiRequest, getMediaUrl } from '../lib/api';

const BlogPostPage = () => {
  const { slug } = useParams();
  const { language } = useLanguage();
  const [post, setPost] = useState(null);
  const [relatedPosts, setRelatedPosts] = useState([]);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    apiRequest(`/api/blog/posts/${slug}`)
      .then((data) => {
        setPost(data);
        return apiRequest('/api/blog/posts?limit=3');
      })
      .then((items) => setRelatedPosts(items.filter((item) => item.slug !== slug).slice(0, 2)))
      .catch(() => setPost(null));
  }, [slug]);

  useEffect(() => {
    const handleScroll = () => {
      const total = document.documentElement.scrollHeight - window.innerHeight;
      setProgress(total > 0 ? (window.scrollY / total) * 100 : 0);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const content = {
    es: { back: 'Volver al blog', related: 'Artículos relacionados' },
    en: { back: 'Back to blog', related: 'Related articles' },
  };

  const t = content[language];

  if (!post) {
    return (
      <section className="blog-page">
        <div className="container">
          <p data-testid="blog-post-not-found">Post not found.</p>
        </div>
      </section>
    );
  }

  return (
    <section className={`blog-post-page layout-${post.layout}`}>
      <div className="blog-reading-progress" style={{ width: `${progress}%` }} data-testid="blog-reading-progress" />
      <div className="container">
        <Link to="/blog" className="blog-back-link" data-testid="blog-post-back-link">{t.back}</Link>
        <div className="blog-post-hero">
          <div className="blog-post-copy">
            <span className="section-eyebrow">{post.categories?.[0] || 'IllumiDev'}</span>
            <h1 data-testid="blog-post-title">{post.title}</h1>
            {post.subtitle && <p data-testid="blog-post-subtitle">{post.subtitle}</p>}
            <div className="blog-meta-row" data-testid="blog-post-meta">
              <span>{post.author_name}</span>
              <span>{new Date(post.published_at || post.created_at).toLocaleDateString()}</span>
            </div>
          </div>
          {post.cover_media_url && (
            <div className="blog-post-cover" data-testid="blog-post-cover">
              <img src={getMediaUrl(post.cover_media_url)} alt={post.title} />
            </div>
          )}
        </div>

        <article className="blog-post-body" data-testid="blog-post-body">
          {post.blocks?.map((block) => <BlogBlockRenderer key={block.id} block={block} />)}
        </article>

        <aside className="blog-related-panel" data-testid="blog-related-panel">
          <h3>{t.related}</h3>
          <div className="blog-related-grid">
            {relatedPosts.map((item) => (
              <Link key={item.id} to={`/blog/${item.slug}`} className="blog-related-link" data-testid={`blog-related-link-${item.slug}`}>
                <strong>{item.title}</strong>
                <span>{item.excerpt}</span>
              </Link>
            ))}
          </div>
        </aside>
      </div>
    </section>
  );
};

export default BlogPostPage;